import React, { useState } from 'react';
import { sound } from '../utils/sound';

interface CompanyGame {
  companyGameId: number;
  game: {
    slug: string;
    name: string;
  };
  cta: string;
  progress?: {
    daysCompleted: number;
    totalDays: number;
  };
}

interface CalendarChoiceScreenProps {
  companyGames: CompanyGame[];
  onSelectGame: (companyGameId: number) => void;
  apiUrl: string;
}

const CalendarChoiceScreen: React.FC<CalendarChoiceScreenProps> = ({
  companyGames,
  onSelectGame,
  apiUrl
}) => {
  const [imageErrors, setImageErrors] = useState<Set<number>>(new Set());

  const handleImageError = (gameId: number) => {
    setImageErrors(prev => new Set(prev).add(gameId));
  };

  const getImageUrl = (game: CompanyGame) => {
    const hasError = imageErrors.has(game.companyGameId);
    if (hasError) {
      // Fallback to a default placeholder image
      return `${apiUrl}/static/previews/default/main.png`;
    }
    return `${apiUrl}/static/previews/${game.game.slug}/main.png`;
  };

  const handleSelectGame = (companyGameId: number) => {
    sound.clickOpen();
    onSelectGame(companyGameId);
  };

  return (
    <div className="calendar-choice-screen">
      <div className="calendar-choice-content">
        <h1 className="calendar-choice-header">Select Your Challenge</h1>
        <div className="calendar-choice-grid">
          {companyGames.map((game) => (
            <button
              key={game.companyGameId}
              className="game-preview-button"
              onClick={() => handleSelectGame(game.companyGameId)}
            >
              <div className="game-preview-name">{game.game.name}</div>
              <div className="game-preview-image-container">
                <img
                  src={getImageUrl(game)}
                  alt={game.game.name}
                  className="game-preview-image"
                  onError={() => handleImageError(game.companyGameId)}
                />
              </div>
              {game.progress && (
                <div className="game-preview-progress">
                  <div
                    className="game-preview-progress-fill"
                    style={{ width: `${(game.progress.daysCompleted / game.progress.totalDays) * 100}%` }}
                  />
                  <div className="game-preview-progress-text">
                    {game.progress.daysCompleted}/{game.progress.totalDays} Days Complete
                  </div>
                </div>
              )}
              <div className="game-preview-cta">{game.cta}</div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CalendarChoiceScreen;
